import { render } from "./AdminParkingAreaView.vue?vue&type=template&id=0af4d292&scoped=true"
import script from "./AdminParkingAreaView.vue?vue&type=script&lang=js"
export * from "./AdminParkingAreaView.vue?vue&type=script&lang=js"

import "./AdminParkingAreaView.vue?vue&type=style&index=0&id=0af4d292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af4d292"]])

export default __exports__